import React from "react";
import { useIdleTimer } from "react-idle-timer";
import swal from "sweetalert";
import { endSessionActivityTracking } from "./sessionActivityTracker";

const SESSION_IDEL_MINUTES = 30;

const AutoLogoutTimer = (props) => {
  const { ComposedClass, type } = props;
  
  const handleOnIdle = (event) => {
    swal({
      title: "Session Expired!",
      text: "Please login again to start the session.",
      icon: "warning",

      dangerMode: true,
    }).then((willDelete) => {
      let path = "/";
      if (type === "user") {
        path = "/";
      } else if (type === "candidate") {
        path = "/careers";
      } else if (type === "consultant") {
        path = "/consultant";
      }

      const clearAndRedirect = () => {
        localStorage.clear();
        window.location.replace(path);
      };

      if (type === "user") {
        endSessionActivityTracking().finally(clearAndRedirect);
      } else {
        clearAndRedirect();
      }
    });
  };

  useIdleTimer({
    timeout: 1000 * 60 * SESSION_IDEL_MINUTES,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return <ComposedClass />;
};

export default AutoLogoutTimer;
